import {
  Tile,
  TileImageSection,
  TileInfoSection
} from '../../VehicleDetailsTile/VehicleDetailsTile.styles';
import {
  SkeletonImage,
  SkeletonTextSmall,
  SkeletonTextMedium
} from '../Skeleton.styles';

export default function VehicleDetailsTileSkeleton() {
  return (
    <Tile className="h-[244px] animate-pulse xl:h-[282px] xl:w-[300px]">
      <TileImageSection className="h-[130px] xl:h-[168px]">
        <SkeletonImage />
      </TileImageSection>
      <TileInfoSection>
        <div className="flex flex-col gap-4">
          <SkeletonTextSmall className="max-w-[200px]" />
          <SkeletonTextSmall className="max-w-[160px]" />
        </div>
        <SkeletonTextMedium className="mt-12 max-w-[100px]" />
      </TileInfoSection>
    </Tile>
  );
}
